// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tf-bold{font-weight:700}.tf-light{font-weight:100}.tf-heading{font-family:bebas-neue-pro,Arial,sans-serif}.tf-body{font-family:montserrat,\"Open Sans\",\"Helvetica Neue\",Arial,sans-serif}.cover{position:absolute;top:0;right:0;bottom:0;left:0}.border-radius{border-radius:5px}#media-map{height:50vh}#media-map :deep(.vue2leaflet-map){height:50vh}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
